module.exports = __webpack_public_path__ + "img/bkjx.4a6efc67.jpg";